const binding = { modules: {}, dataActions: {} };

    (binding.modules['hso-cookie-compliance'] = {
        c: () => require('partner/modules/hso-cookie-compliance/hso-cookie-compliance.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hso-cookie-compliance',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hso-cookie-compliance'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|hso-cookie-compliance|hso-cookie-compliance'] = {
                c: () => require('partner/modules/hso-cookie-compliance/hso-cookie-compliance.view.tsx'),
                cn: '__local__-__local__-hso-cookie-compliance'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };